module.exports = __webpack_public_path__ + "static/media/dark_pit.71b59a77.png";